<div class="accordion" id="accordionExample" style="margin-top: -25px;">
    <div class="accordion-item">
        <h2 class="accordion-header" id="heading1">
            <button aria-controls="collapse1" aria-expanded="false" class="accordion-button collapsed"
                    data-bs-target="#collapse1" data-bs-toggle="collapse" type="button">
                Aanvragen van toeslagen
            </button>
        </h2>
        <div aria-labelledby="heading1" class="accordion-collapse collapse" data-bs-parent="#accordionExample"
             id="collapse1">
            <div class="accordion-body">
                <b>Wat kun je hier verwachten?</b><br/>
                Met deze module toeslagen regel je eenvoudig het aanvragen van toeslagen. Eenmaal aangevraagde toeslagen
                kun je hier ook wijzigen. En in het dossier van de toeslagen vind je ook beschikkingen, zoals de
                berekening van
                het toeslag. De berekeningen zijn voor de aanvragers ook altijd beschikbaar in hun Berichtenbox op
                MijnOverheid.

                <div class="space10"></div>

                <b>De volgende toeslagen kunnen aangevraagd worden</b>:
                <li class="list">zorgtoeslag</li>
                <li class="list">kindgebonden budget</li>
                <li class="list">kinderopvangtoeslag</li>
                <li class="list">huurtoeslag</li>
                <div class="space10"></div>

            </div>
        </div>
    </div>

    <div class="accordion-item">
        <h2 class="accordion-header" id="heading2">
            <button aria-controls="collapse2" aria-expanded="false" class="accordion-button collapsed"
                    data-bs-target="#collapse2" data-bs-toggle="collapse" type="button">
                Toetsinkomen invullen
            </button>
        </h2>
        <div aria-labelledby="heading2" class="accordion-collapse collapse" data-bs-parent="#accordionExample"
             id="collapse2">
            <div class="accordion-body">
                <b>Waarom toetsinkomen invullen?</b><br/>
                Als je toeslag aanvraagt, dan moet je je toetsingsinkomen voor dat jaar opgeven. Ook als je maar voor
                een deel van het jaar toeslag aanvraagt, geef je voor het hele jaar het inkomen op. Het inkomen telt
                mee voor de hoogte van het toeslag.
                <div class="space10"></div>

                <b>Toetsingsinkomen</b><br/>
                Wat het toetsingsinkomen is, hangt af van het situatie:
                <li class="list">Doe je belastingaangifte? Dan is het toetsingsinkomen gelijk aan het verzamelinkomen
                    uit het definitieve aanslag inkomstenbelasting.
                </li>
                <li class="list">Doe je geen belastingaangifte? Dan is het toetsingsinkomen gelijk aan het belastbare
                    loon. Het belastbare loon staat op het jaaropgaaf. Het wordt ook wel 'bedrag voor de loonheffingen
                    (LH of LB)' of 'fiscaal loon' genoemd.
                </li>
                <div class="space10"></div>

                <b>Het toetsingsinkomen als het jaar nog niet voorbij is</b><br/>
                Is het jaar nog niet voorbij? Dan heb je nog geen definitieve belastingaanslag of jaaropgaaf
                gekregen. Je moet het inkomen dan zo goed mogelijk schatten.
            </div>
        </div>
    </div>

    <div class="accordion-item">
        <h2 class="accordion-header" id="heading3">
            <button aria-controls="collapse3" aria-expanded="false" class="accordion-button collapsed"
                    data-bs-target="#collapse3" data-bs-toggle="collapse" type="button">
                Wat behoort tot het toetsinkomen?
            </button>
        </h2>
        <div aria-labelledby="heading3" class="accordion-collapse collapse" data-bs-parent="#accordionExample"
             id="collapse3">
            <div class="accordion-body">
                <b>Inkomens die meetellen</b>

                <li class="list">inkomsten uit werk</li>
                <li class="list">uitkering, bijvoorbeeld een werkloosheidsuitkering (WW), bijstandsuitkering of een
                    uitkering bij
                    ziekte
                </li>
                <li class="list">pensioen, bijvoorbeeld een ouderdomspensioen (AOW) of bedrijfspensioen</li>
                <li class="list">ontslagvergoeding</li>
                <li class="list">andere inkomsten, zoals alimentatie voor uzelf, bijverdiensten als freelancer of
                    gastouder
                </li>
                <li class="list">inkomsten uit verhuur eigen woning</li>
                <div class="space10"></div>

                <b>Buitenlands inkomen telt ook mee</b><br/>
                Er is buitenlands inkomen als je bijvoorbeeld in het buitenland werkt voor een buitenlandse
                werkgever. Of als je in het buitenland hebt gewerkt en nu pensioen krijgt van het buitenlandse
                werkgever.<br/>
                Elk jaar vraagt de Belastingdienst om het buitenlands inkomen door te geven. Deze gegevens hebben ze
                nodig om het inkomen te bepalen. De Belastingdienst stuurt je hiervoor het formulier Opgaaf
                wereldinkomen. Meer informatie vind je <a
                    href="https://www.belastingdienst.nl/wps/wcm/connect/nl/buitenland/content/hoe-kom-ik-aan-het-formulier-opgaaf-wereldinkomen"
                    target="_blank">hier</a>.
                <div class="space10"></div>

                <b>Internationaal vrijgesteld inkomen telt ook mee</b><br/>
                Iemand heedt internationaal vrijgesteld inkomen als het inkomen is dat volgens internationale regelingen
                is vrijgesteld van inkomstenbelasting. Bijvoorbeeld als de persoon werkt bij een internationale
                organisatie als de Verenigde Naties, de Europese Unie of het Internationaal Gerechtshof.
            </div>
        </div>
    </div>

    <div class="accordion-item">
        <h2 class="accordion-header" id="heading4">
            <button aria-controls="collapse4" aria-expanded="false" class="accordion-button collapsed"
                    data-bs-target="#collapse4" data-bs-toggle="collapse" type="button">
                Wat behoort niet tot het toetsinkomen?
            </button>
        </h2>
        <div aria-labelledby="heading4" class="accordion-collapse collapse" data-bs-parent="#accordionExample"
             id="collapse4">
            <div class="accordion-body">
                <b>Inkomens die niet meetellen</b><br/>
                <li class="list">zorgtoeslag, huurtoeslag, kinderopvangtoeslag en kindgebonden budget</li>
                <li class="list">studiefinanciering volgens de Wet studiefinanciering (WSF)</li>
                <li class="list">toelage volgens de Wet tegemoetkoming onderwijsbijdrage en schoolkosten (WTOS)</li>
                <li class="list">Tegemoetkoming arbeidsongeschikten (eerst: Wet tegemoetkoming chronisch zieken en
                    gehandicapten
                    (Wtcg))
                </li>
                <li class="list"> een studielening</li>
                <li class="list">een studie-uitkering die je 1 keer krijgt</li>
                <li class="list">kinderbijslag</li>
                <li class="list">een pleegzorgvergoeding</li>
                <li class="list">vrijwilligersvergoeding tot aan een bepaalde grens</li>
                <li class="list">alimentatie die je krijgt voor het kinderen</li>
                <li class="list">teruggaaf inkomstenbelasting</li>
                <li class="list">persoonsgebonden budget (pgb) dat je als budgethouder krijgt voor het kopen van zorg.
                    Biedt je zorg
                    en wordt je hiervoor betaald uit pgb? Dan telt dit wél als inkomen.
                </li>
                <div class="space10"></div>

                <b>Kwijtscheldingswinst voor ondernemers</b><br/>
                Is iemand ondernemer en had die persoon een schuld die hij/zij niet meer hoeft terug te betalen? Dan
                levert dat de ondernemer
                'kwijtscheldingswinst' op. Hierdoor kan het toetsingsinkomen hoger worden.<br/>
                Moet de ondernemer hierdoor toeslag terugbetalen? Dan kan de ondernemer de Belastingdienst vragen om de
                kwijtscheldingswinst niet mee te laten tellen bij het toetsingsinkomen. Lees <a
                    href="https://www.belastingdienst.nl/wps/wcm/connect/bldcontentnl/belastingdienst/prive/toeslagen/hoe_werken_toeslagen/kan_ik_toeslag_krijgen/inkomen/kwijtscheldingswinst-ondernemers"
                    target="_blank">hier</a>
                meer.
            </div>
        </div>
    </div>

    <div class="accordion-item">
        <h2 class="accordion-header" id="heading7">
            <button aria-controls="collapse7" aria-expanded="false" class="accordion-button collapsed"
                    data-bs-target="#collapse7" data-bs-toggle="collapse" type="button">
                Toetsvermogen invullen
            </button>
        </h2>
        <div aria-labelledby="heading7" class="accordion-collapse collapse" data-bs-parent="#accordionExample"
             id="collapse7">
            <div class="accordion-body">
                <b>Waarom toetsvermogen invullen?</b><br/>
                Voor zorgtoeslag, kindgebonden budget en huurtoeslag telt je vermogen ook mee. Heb je of heeft je
                toeslagpartner vermogen, zoals spaargeld of beleggingen? Als dat bedrag te hoog is, kun je geen
                huurtoeslag, zorgtoeslag of kindgebonden budget krijgen.
                <div class="space10"></div>

                <snelstart-ui-alert type="warning">
                    <b>LET OP!</b>
                    Let op! Het ingevulde vermogen wordt alleen gebruikt voor de berekening van de toeslagen. Het
                    vermogen
                    gaat niet mee in het elektronisch bericht. Het doorgeven van een wijziging voor het vermogen is niet
                    mogelijk via Snelstart Fiscaal. Een wijziging in het vermogen kan de aanvragen wel doorgeven via
                    MijnToeslagen van de Belastingdienst.
                </snelstart-ui-alert>

                Voor de huurtoeslag telt ook het vermogen van medebewoners mee.
                <div class="space10"></div>

                <b>Wat is vermogen?</b><br/>
                Vermogen is de waarde van de bezittingen min uw schulden. Wat je wel en niet als vermogen moet
                meetellen, is hetzelfde als bij uw belastingaangifte. Spaargeld, aandelen en een vakantiehuis in
                Nederland of het buitenland tellen bijvoorbeeld mee. Maar het huis waarin je woont en de auto tellen
                níét mee als vermogen.
                <div class="space10"></div>

                <b>Hoeveel vermogen mag je hebben?</b><br/>
                Jaarlijks wijzigen niet alleen de bedragen van de toeslagen, maar ook de inkomens- en vermogensgrenzen.
                Bekijk welke grenzen er zijn voor het vermogen via onderstaande links.
                <div class="space10"></div>

                <li class="list"><a
                        href="https://www.belastingdienst.nl/wps/wcm/connect/bldcontentnl/belastingdienst/prive/toeslagen/huurtoeslag/uw-vermogen-is-niet-te-hoog-voor-de-huurtoeslag/vermogen-huurtoeslag"
                        target="_blank">maximaal vermogen voor de huurtoeslag</a></li>
                <li class="list"><a
                        href="https://www.belastingdienst.nl/wps/wcm/connect/bldcontentnl/belastingdienst/prive/toeslagen/zorgtoeslag/voorwaarden/vermogen/hoeveel-vermogen-mag-ik-hebben-voor-zorgtoeslag"
                        target="_blank">maximaal vermogen voor de zorgtoeslag</a></li>
                <li class="list"><a
                        href="https://www.belastingdienst.nl/wps/wcm/connect/bldcontentnl/belastingdienst/prive/toeslagen/kindgebonden-budget/voorwaarden/vermogen/vermogen-kindgebonden-budget"
                        target="_blank">maximaal vermogen voor kindgebonden budget</a></li>

            </div>
        </div>

    </div>
    <div class="accordion-item">
        <h2 class="accordion-header" id="heading8">
            <button aria-controls="collapse8" aria-expanded="false" class="accordion-button collapsed"
                    data-bs-target="#collapse8" data-bs-toggle="collapse" type="button">
                Wat telt mee als vermogen?
            </button>
        </h2>
        <div aria-labelledby="heading8" class="accordion-collapse collapse" data-bs-parent="#accordionExample"
             id="collapse8">
            <div class="accordion-body">
                <li class="list">Vermogen van je toeslagpartner telt ook mee.</li>
                <li class="list">Heb je een thuiswonend kind dat jonger is dan 18 jaar? Dan telt het vermogen van dit
                    kind mee bij je vermogen. <br/>
                    Wonen jij en de andere ouder niet meer bij elkaar? Dan telt het vermogen van je minderjarige
                    kind meestal maar voor de helft mee.
                </li>
                <li class="list">Voor de huurtoeslag telt ook het vermogen van medebewoners mee.<br/>
                    Heb je maar voor een deel van het jaar een toeslagpartner of een medebewoner? Dan telt zijn vermogen
                    niet mee.
                </li>
                <li class="list">Groene beleggingen tellen wél voor de toeslagen mee als vermogen. Alleen voor de
                    belastingaangifte kun je hiervoor een vrijstelling krijgen.
                </li>
                <li class="list">Bijzonder vermogen telt niet mee voor de berekening van je vermogen voor uw toeslagen.
                    Het kan wél meetellen voor de berekening van uw toetsingsinkomen.<br/>
                    Als je vermogen te hoog is, kun je geen huurtoeslag, zorgtoeslag of kindgebonden budget krijgen. In
                    sommige situaties kun je de Belastingdienst ons vragen om 'bijzonder vermogen' niet mee te tellen
                    als vermogen. Je kunt dan misschien toch toeslag krijgen.
                    <div class="space10"></div>
                    De volgende vermogens vallen onder bijzonder vermogen:<br/>
                    - Vermogen van kinderen<br/>
                    - Smartengeld<br/>
                    - Vergoedingen voor ziekte en lichamelijk letsel<br/>
                    - Vergoedingen voor de gevolgen van oorlog en conflicten<br/>
                    - Vergoedingen voor seksueel misbruik<br/>
                    - Tegemoetkomingen voor transgender en intersekse personen<br/>
                    - Nabetalingen van kindgebonden budget<br/>
                    - Corona-uitkeringen in de zorg<br/>
                    - Compensatiebetalingen voor kinderopvangtoeslag<br/>
                    - Uitkering eenmalig bedrag ouderen van Surinaamse herkomst<br/>
                    <div class="space10"></div>
                    Je geeft bijzonder vermogen aan de Belastingdienst door met het formulier <a
                            href="https://www.belastingdienst.nl/wps/wcm/connect/bldcontentnl/themaoverstijgend/programmas_en_formulieren/formulier_verzoek_bijzonder_vermogen_toeslagen"
                            target="_blank">Verzoek bijzonder vermogen toeslagen</a> of met een brief.
                </li>
            </div>
        </div>
    </div>

    <div class="accordion-item">
        <h2 class="accordion-header" id="heading11">
            <button aria-controls="collapse11" aria-expanded="false" class="accordion-button collapsed"
                    data-bs-target="#collapse11" data-bs-toggle="collapse" type="button">
                Gegevens uit aangifte inkomstenbelasting
            </button>
        </h2>
        <div aria-labelledby="heading11" class="accordion-collapse collapse" data-bs-parent="#accordionExample"
             id="collapse11">
            <div class="accordion-body">
                Wanneer er in SnelStart Fiscaal een belastingaangifte voor het aanvraagjaar is aangemaakt/ingevuld, dan
                worden de gegevens uit deze aangifte overgenomen voor de toeslagen. Het gaat dan om de gegevens inzake
                partner, kinderen, inkomen en vermogen.
                <div class="space10"></div>
                Je kunt in de aanvraag Toeslagen deze gegevens wijzigen en de aanvraag indienen bij de Belastingdienst.
                In je dossier Toeslagen ontvang je een bevestiging van het indienen bij en ontvangen door de
                Belastingdienst. Daar zit ook een pdf-rapport van hetgeen is ingediend.<br/>
                Omdat de gegevens uit de module aangifte Inkomstenbelasting gekoppeld zijn aan de module Toeslagen zul
                je zien dat bij het opnieuw openen van de aanvraag Toeslagen de gegevens uit de aangifte
                inkomstenbelasting weer vermeld zijn in de aanvraag. Maar wees gerust, dat zijn dus niet de gegevens die
                in de eerdere (eventuele) aanvraag naar de Belastingdienst zijn verzonden.
            </div>
        </div>
    </div>


    <div class="accordion-item">
        <h2 class="accordion-header" id="heading19">
            <button aria-controls="collapse19" aria-expanded="false" class="accordion-button collapsed"
                    data-bs-target="#collapse19" data-bs-toggle="collapse" type="button">
                Toeslagpartner
            </button>
        </h2>
        <div aria-labelledby="heading19" class="accordion-collapse collapse" data-bs-parent="#accordionExample"
             id="collapse19">
            <div class="accordion-body">
                Voor toeslagen hebben we het over een 'toeslagpartner'. Een toeslagpartner is iemand die meetelt voor de
                toeslagen. Dit betekent dat het inkomen en vermogen van u allebei meetelt voor de toeslag, en dat je de
                toeslag samen krijgt. Je toeslagpartner kan uw echtgenoot of geregistreerd partner zijn, of iemand
                anders die op uw adres staat ingeschreven. Je kunt maar 1 toeslagpartner hebben.
                <div class="space10"></div>
                Lees meer bij <a
                    href="https://www.belastingdienst.nl/wps/wcm/connect/nl/toeslagen/content/toeslagpartner"
                    target="_blank">Toeslagpartner voor de toeslagen</a>.
            </div>
        </div>
    </div>

    <div class="accordion-item">
        <h2 class="accordion-header" id="heading9">
            <button aria-controls="collapse9" aria-expanded="false" class="accordion-button collapsed"
                    data-bs-target="#collapse9" data-bs-toggle="collapse" type="button">
                Niet het hele jaar elkaars toeslagpartner? Let op verdelen box 3-vermogen!
            </button>
        </h2>
        <div aria-labelledby="heading9" class="accordion-collapse collapse" data-bs-parent="#accordionExample"
             id="collapse9">
            <div class="accordion-body">
                Bijvoorbeeld omdat jij en je partner uit elkaar zijn gegaan, zijn gaan samenwonen of omdat uw partner is
                overleden? Maar kies je er wél voor om fiscale partners te zijn en samen belastingaangifte te doen? Let
                er dan goed op hoe je in de belastingaangifte het box 3-vermogen over u beiden verdeelt. Zo zorg je
                ervoor dat je je huurtoeslag, zorgtoeslag of kindgebonden budget niet of minder terug hoeft te betalen.
                <div class="space10"></div>
                Lees meer bij <a
                    href="https://www.belastingdienst.nl/wps/wcm/connect/nl/toeslagen/content/vermogen-verdelen-belastingaangifte-toeslagen"
                    target="_blank">Vermogen verdelen als je maar een deel van het jaar een toeslagpartner hebt</a>.
            </div>
        </div>
    </div>

    <div class="accordion-item">
        <h2 class="accordion-header" id="heading6">
            <button aria-controls="collapse6" aria-expanded="false" class="accordion-button collapsed"
                    data-bs-target="#collapse6" data-bs-toggle="collapse" type="button">
                Het inkomen en/of vermogen wijzigt
            </button>
        </h2>
        <div aria-labelledby="heading6" class="accordion-collapse collapse" data-bs-parent="#accordionExample"
             id="collapse6">
            <div class="accordion-body">
                <b>Het inkomen verandert</b><br/>
                Blijkt tijdens het jaar dat er iets verandert in het inkomen, het vermogen of aftrekposten voor de
                inkomstenbelasting? Dan moet je het toetsingsinkomen en het vermogen opnieuw schatten en aan de
                Belastingdienst doorgeven.
            </div>
        </div>
    </div>

    <div class="accordion-item">
        <h2 class="accordion-header" id="heading10">
            <button aria-controls="collapse10" aria-expanded="false" class="accordion-button collapsed"
                    data-bs-target="#collapse10" data-bs-toggle="collapse" type="button">
                Nederlandse zorgverzekering
            </button>
        </h2>
        <div aria-labelledby="heading10" class="accordion-collapse collapse" data-bs-parent="#accordionExample"
             id="collapse10">
            <div class="accordion-body">
                Een zorgverzekering is niet goedkoop. Daarom is er zorgtoeslag: een bijdrage van de overheid om de
                zorgverzekering betaalbaar te houden. Om recht op zorgtoeslag te hebben, moet je in ieder geval een
                Nederlandse zorgverzekering hebben.
            </div>
        </div>
    </div>

    <div class="accordion-item">
        <h2 class="accordion-header" id="heading12">
            <button aria-controls="collapse12" aria-expanded="false" class="accordion-button collapsed"
                    data-bs-target="#collapse12" data-bs-toggle="collapse" type="button">
                Tot wanneer kan ik zorgtoeslag aanvragen?
            </button>
        </h2>
        <div aria-labelledby="heading12" class="accordion-collapse collapse" data-bs-parent="#accordionExample"
             id="collapse12">
            <div class="accordion-body">
                De zorgtoeslag, huurtoeslag en kindgebonden budget kun je nog aanvragen tot en met 1 september in het
                volgende jaar. Je kunt bijvoorbeeld nog zorgtoeslag over 2024 aanvragen tot en met 1 september 2025.
                <div class="space10"></div>
                Heb je nog vóór 2 september van het nieuwe jaar toeslag over het voorgaande jaar aangevraagd? Dan kan
                het een tijdje duren voordat je de toeslag krijgt. Je moet eerst wachten op de definitieve berekening
                van het voorgaande jaar. Binnen 1 week nadat je deze hebt gekregen, maakt de Belastingdienst het bedrag
                in 1 keer aan je over.
                <div class="space10"></div>

                <b>Stopgezette toeslag</b><br/>
                Had je al een toeslag die je hebt stopgezet? En wil je deze opnieuw aanvragen? Dan heb je langer de
                tijd. Je kunt die toeslag nog aanvragen ná 1 september van het volgende jaar. Aanvragen kan dan niet
                meer via online, ook niet via Mijn toeslagen. Schrijf de Belastingdienst een <a
                    href="https://www.belastingdienst.nl/wps/wcm/connect/bldcontentnl/belastingdienst/prive/toeslagen/hoe_werken_toeslagen/niet_met_ons_eens_toeslagen/verzoek-om-een-beslissing-over-een-toeslag-te-herzien"
                    target="_blank">brief</a> en vraag de Belastingdienst om de ‘stopzetting te herzien’.
                <div class="space10"></div>

                <b>Uitstel voor de aangifte inkomstenbelasting</b><br/>
                Dan heb je meer tijd om toeslag aan te vragen. Want je kunt dan nog zorgtoeslag, huurtoeslag en
                kindgebonden budget aanvragen tot de datum waarop het uitstel afloopt. Dat kan uitstel zijn voor de
                aangifte óf voor de aangifte van je toeslagpartner. Huurtoeslag kun je ook aanvragen zolang een
                medebewoner nog uitstel heeft.
                <div class="space10"></div>


            </div>
        </div>

    </div>

